// Selector de país del catálogo `financiero.paises`.
//
// Existe porque el país estuvo siendo un campo de texto libre en varias
// pantallas y acabó conviviendo «Ecuador» con «EC», con vacíos y con NULL en la
// misma columna (script 854 lo normalizó). Un dato de catálogo se elige, no se
// teclea.
//
// Guarda el NOMBRE del país, que es lo que las tablas almacenan hoy
// (`financiero.partner.pais`), no el código ISO.
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';

export interface PaisCatalogo {
  codigo: string; nombre: string; nacionalidad: string | null; codigo_telefono: string | null;
}

/** El catálogo, cacheado para toda la sesión: cambia una vez al año, si acaso. */
export function usePaises() {
  return useQuery<PaisCatalogo[]>({
    queryKey: ['catalogo-paises'],
    queryFn: async () => (await apiClient.get(
      '/paises?select=codigo,nombre,nacionalidad,codigo_telefono&activo=eq.true&order=orden,nombre',
      { headers: { 'Accept-Profile': 'financiero' } })).data ?? [],
    staleTime: Infinity,
  });
}

export function SelectPais({ value, onChange, className, placeholder = '—', disabled }: {
  value: string;
  onChange: (v: string) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  const { data: paises = [] } = usePaises();
  // Un valor guardado que ya no está en el catálogo se ofrece igual: editar otro
  // campo del formulario no debe cambiarle el país por detrás a nadie.
  const fueraDeCatalogo = value && !paises.some((p) => p.nombre === value);

  return (
    <select className={className} value={value} disabled={disabled}
            onChange={(e) => onChange(e.target.value)}>
      <option value="">{placeholder}</option>
      {fueraDeCatalogo && <option value={value}>{value}</option>}
      {paises.map((p) => <option key={p.codigo} value={p.nombre}>{p.nombre}</option>)}
    </select>
  );
}
